import React, { Component } from 'react'
import InputMask from 'react-input-mask'
import moment from 'moment'
import DOMPurify from 'dompurify';

import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import Privacy from '../common/privacy'
import Controls from '../common/controls'
import RadioButton from '../common/radioButton'
import RadioGroup from '../common/radioGroup'

import RegexVerification from './regex_verification'
import queryString from 'query-string'

export default class Registration1 extends Component {
  constructor(props) {
    super(props)

    this.props.updateActivePage(1)
    const code = queryString.parse(window.location.search)
    let initialRCode = ''
    if (code.regCode) initialRCode = code.regCode
    this.required = {
        fName: { required: this.props.UseNameForVerification },
        lName: { required: this.props.UseNameForVerification },
        dob: { required: this.props.UseDOBForVerification },
        email: { required: this.props.collectEmail }, 
        rCode: { required: true }, 
        verCode: { required: this.props.UseVerificationCode }, 
        spouseSelection: { required: this.props.UseVerificationCode && this.props.UseEmployeeSpouseSelection }, 
    }

    this.state = this.props.collectEmail ? {
      input: { 
        fName: { value: '', type: 'text' },
        lName: { value: '', type: 'text' },
        dob: { value: '', type: 'text' },
        email: { value: '', type: "text" }, 
        rCode: { value: initialRCode, type: 'text' }, 
        verCode: { value: '', type: 'text' }, 
        spouseSelection: { value: '', type: 'radio' }, 
      },
      submitAfterVerError: false,
      submitClick: false,
      hasChanged: false,
      emailUniqueP1: true
    } : {
      input: { 
        fName: { value: '', type: 'text' },
        lName: { value: '', type: 'text' },
        dob: { value: '', type: 'text' },
        rCode: { value: initialRCode, type: 'text' },
        verCode: { value: '', type: 'text' }, 
        spouseSelection: { value: '', type: 'radio' }, 
      },
      submitClick: false,
      hasChanged: false,
      emailUniqueP1: true
    }

    this.focusElements = {}

    for (let name in this.state.input) {
      this.focusElements[name] = React.createRef()
    }
   
    this.displayErrors = this._displayErrors.bind(this)
    this.verificationError = this._verificationError.bind(this)
    this.updateFromHistory = this._updateFromHistory.bind(this)
    this.next = this._next.bind(this)
  }

  handleChange(name, valueOrEvent) {
    switch (this.state.input[name].type) {
      case 'text':
        const curInputValue = valueOrEvent.target.value
        this.handleStateChange(name, curInputValue)
        break
      case 'radio':
          this.handleStateChange(name, valueOrEvent)
          break
    }
    if (!this.state.hasChanged) {
      this.setState({ hasChanged: true })
    }
  }

  handleStateChange(name, value) {
    this.setState({ 
      input: { ...this.state.input,
        [name]: {...this.state.input[name], 
          value: value 
        }
      }
    }, () => {
      this.props.replaceHistoryState(this.state, this.props.history)
    })
  }

  async _next(e) {
    e.preventDefault()
      this.setState({ 
        submitClick: true,
        submitAfterVerError: true 
      })
      for (let property in this.state.input) {
        if (this.required[property].required && !this.isValid(property)) {
          this.focusElements[property].focus()
          return
        }
      }
    return this.props.next(this.props.match.path, this.state)
  }

  isEmpty(name) {
    if (this.state.input[name].value === '') return true
    return false
  }

  isValid(name) {
    if (name === 'dob') {
      const parsedDob = this.parseDob(this.state.input.dob.value)
      let dob = moment(parsedDob)
      let yearsOld = moment().diff(parsedDob, 'years')
      let oldestDate = moment('1900-01-01')
      if (yearsOld >= 18 && oldestDate <= dob) {
        return true
      }
      return false
    } else if (name === 'verCode') {
      return RegexVerification[this.props.ValidateOn].test(this.state.input[name].value)
    } else if (name === 'spouseSelection') {
      return !this.isEmpty(name)
    }
    return RegexVerification[name].test(this.state.input[name].value)
  }

  parseDob(dob) {
    let newDate = dob.split('/').reverse()
    const day = newDate[1]
    newDate[1] = newDate[2]
    newDate[2] = day
    return newDate.join('-')
  }

  _verificationError() {
    let errorText = ""
    if (this.props.verError === 400) {
      errorText = "The information entered does not match our records. Please ensure your data is correct or call Client Care at 1-888-639-8181 if you think you are eligible."
    } else if (this.props.verError && this.props.verErrorMessage != 'DuplicateEmail') {
      if (this.props.verErrorMessage === "JPMC not eligible A") {
        return (
          <div aria-live="polite" className="error">You are not currently eligible for this program, please go to Virgin Pulse to view your Additional Wellness Activities.</div>
        )
      }
      else if (this.props.verErrorMessage === "JPMC not eligible X") {
        return (
          <div aria-live="polite" className="error">You must complete a Wellness Screening to participate in Additional Wellness Activities. Please go to My Health (<a class="error-link" href="https://myhealth.jpmorganchase.com" target="_blank" rel="noopener noreferrer">myhealth.jpmorganchase.com</a> or type go/myhealth into your intranet browser) for information on how to get your screening.</div>
        )
      }
      else if (this.props.verErrorMessage === "Not eligible") {
        return (
          <div aria-live="polite" className="error">Based on your employer’s eligibility criteria, you cannot register for the Newtopia program. Please contact your HR group to find out what other programs are being offered that may be a better fit for you.</div>
        )
      }
      else if (this.props.verErrorMessage === "Participant Next Step URL not found") {
        return (
          <div aria-live="polite" className="error">An error occurred during the registration process. Please contact the Client Care team.</div>
        )
      }
      errorText = "We encountered a technical issue. Please contact our Client Care."
    }
    return (
      <div aria-live="polite" className="error">{errorText}</div>
    )
  }

  _displayErrors(name, errorId) {
    if (
        name === 'email' 
        && this.state.submitAfterVerError 
        && this.props.verError 
        && this.props.verErrorMessage === 'DuplicateEmail'
      ) {
        this.focusElements['email'].focus()
        return (
          <div id={errorId} className="error">This email id is already registered with Newtopia. Please use another email or Call Client Care at 1-888-639-8181.</div>
        )
    }
    if (this.state.submitClick) {
      if (!this.isValid(name) && this.isEmpty(name)) {
        return (
          <div id={errorId} className="error">This field is required.</div>
        )
      } else if (!this.isValid(name)) {
        switch (name) {
          case 'dob':
            return (
              <div id={errorId} className="error">Invalid date.</div>
            )
          default:
            return (
              <div id={errorId} className="error">Invalid input.</div>
            )
        }
      }
    }
    return (
      <div id={errorId} className="error"></div>
    )
  }

  makeRef(name, ref) {
    this.focusElements[name] = ref
  }

  _updateFromHistory() {
    if (this.props.history.location.state) {
      const historyState = this.props.history.location.state
      let newInputState = {}
      for (let property in this.state.input) {
        if (historyState[property]) {
          newInputState[property] = historyState[property]
        }
      }
      this.setState({ 
        input: { ...this.state.input,
          ...newInputState
        }
      })
    }
  }
  
  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus() 
    window.scrollTo(0, 0)
    this.updateFromHistory()
  }

  render() {
    let purifiedVerificationPageInstructions = null
    let purifiedVerificationPageDescription = null
    if (this.props.VerificationPageInstructions != null) {
      purifiedVerificationPageInstructions = DOMPurify.sanitize(this.props.VerificationPageInstructions);
    }
    if (this.props.VerificationPageDescription != null) {
      purifiedVerificationPageDescription = DOMPurify.sanitize(this.props.VerificationPageDescription);
    }
    let spouseSelectionInitial = ""
    const historyState = this.props.history.location.state
    if (historyState && historyState.spouseSelection) {
        spouseSelectionInitial = historyState.spouseSelection.value
    } 
    return (
      <div id="registration_1">
        <AriaMessage message="Navigated to registration page 1" />
        <Title>Registration</Title>
        <div className="container form-container">
          { this.props.VerificationPageDescription != null &&
            <label className="browser-message"><div dangerouslySetInnerHTML={{ __html: purifiedVerificationPageDescription}}/></label>
          }
          <h2>Let's get started</h2>
          { this.props.UseNameForVerification &&
            <div className="form-row">
              <div className="form-input">
                <label for="first-name" id="registration_p1_first_name_text" className="form-heading"> First Name </label>
                <input
                  name="first-name"
                  ref={this.makeRef.bind(this, "fName")}
                  value={this.state.input.fName.value}
                  type="text"
                  id="registration_p1_first_name"
                  placeholder="Enter name here"
                  aria-labelledby="registration_p1_first_name_text"
                  aria-describedby="registration_p1_first_name_error"
                  onChange={this.handleChange.bind(this, "fName")}
                  data-atid="reg_p1_first_name" 
                />
                {this.displayErrors("fName", "registration_p1_first_name_error")}
              </div>
              <div className="form-input">
                <label for="registration_p1_last_name" id="registration_p1_last_name_text" className="form-heading"> Last Name </label>
                <input
                  ref={this.makeRef.bind(this, "lName")}
                  value={this.state.input.lName.value}
                  type="text"
                  id="registration_p1_last_name"
                  placeholder="Enter name here"
                  aria-labelledby="registration_p1_last_name_text"
                  aria-describedby="registration_p1_last_name_error"
                  onChange={this.handleChange.bind(this, "lName")}
                  data-atid="reg_p1_last_name" 
                />
                {this.displayErrors("lName", "registration_p1_last_name_error")}
              </div>
            </div>
          }
          { this.props.collectEmail && 
            <div>
              <div id="registration_p1_email_text">
                <label for="registration_p1_email">
                  <div className="form-heading">Email</div>
                  <div>
                    Please enter your <b>personal email</b> for Newtopia to
                    communicate with you.
                  </div>
                </label>
              </div>
              <input
                ref={this.makeRef.bind(this, "email")}
                value={this.state.input.email.value}
                id="registration_p1_email"
                type="text"
                placeholder="Enter email here"
                aria-labelledby="registration_p1_email_text"
                aria-describedby="registration_p1_email_error"
                onChange={this.handleChange.bind(this, "email")}
                data-atid="reg_p1_email"
                style={{width:"500px"}}
              />
              {this.displayErrors("email", "registration_p1_email_error")}
            </div>
          }
          { this.props.UseDOBForVerification &&
            <div className="form-input">
              <div id="registration_p1_dob_text">
                <label for="registration_p1_dob"> 
                  <div className="form-heading">
                    Date of Birth 
                  </div>
                  <div>
                    Please enter your date of birth in the format of MM/DD/YYYY.
                  </div>
                </label>
              </div>
              <InputMask
                id="registration_p1_dob"
                mask="99/99/9999"
                className="form-input-text"
                value={this.state.input.dob.value}
                placeholder="MM/DD/YYYY"
                aria-labelledby="registration_p1_dob_text"
                aria-describedby="registration_p1_dob_error"
                onChange={this.handleChange.bind(this, "dob")}
                inputRef={this.makeRef.bind(this, "dob")}
                data-atid="reg_p1_dob"
              />
              {this.displayErrors("dob", "registration_p1_dob_error")}
            </div>
          }
          { this.props.UseVerificationCode &&
            <div className="form-input">
              <div id="registration_p1_verification_code_text">
                <label for="registration_p1_verification_code"> 
                  <div className="form-heading">
                    {this.props.VerificationPageTitle}
                  </div>
                </label>
              </div>
              {this.props.UseEmployeeSpouseSelection &&
                <div className="form-input">
                  <br/>
                  <RadioGroup
                    name="spouseSelection"
                    initial={spouseSelectionInitial}
                    ariaLabelledby="registration_p3_spouse_text"
                    radioRef={this.makeRef.bind(this, "spouseSelection")}
                    ariaDescribedby="registration_p3_spouse_error"
                    onChange={this.handleChange.bind(this, "spouseSelection")}
                    dataAtId="reg_p3_spouseSelection"
                  >
                    <RadioButton value="false" label={this.props.SelectEmployeeButtonLabel} />
                    <RadioButton value="true" label={this.props.SelectSpouseButtonLabel} />
                  </RadioGroup>
                  {this.displayErrors("spouseSelection", "registration_p3_spouse_error")}
                  <br/>
                </div>
              }
              <div id="registration_p1_verification_code_text">
                <label for="registration_p1_verification_code">
                  <p><div dangerouslySetInnerHTML={{ __html: purifiedVerificationPageInstructions}}/></p>
                </label>
              </div>
              <input
                ref={this.makeRef.bind(this, "verCode")}
                value={this.state.input.verCode.value}
                type="text"
                id="registration_p1_verification_code"
                placeholder="Enter here"
                aria-labelledby="registration_p1_verification_code_text"
                aria-describedby="registration_p1_verification_code_error"
                onChange={this.handleChange.bind(this, "verCode")}
                data-atid="reg_p1_regcode"
              />
              {this.displayErrors("verCode", "registration_p1_verification_code_error")}
            </div>
          }
          <div className="form-input">
            <div id="registration_p1_register_code_text">
              <label for="registration_p1_register_code"> 
                <div className="form-heading">
                  Registration Code
                </div>
                <div>
                  If your code is not pre-populated below it can be found in the e-mail we sent you. Can't find it? Call us at: 1-888-639-8181.
                </div>
              </label>
            </div>
            <input
              ref={this.makeRef.bind(this, "rCode")}
              value={this.state.input.rCode.value}
              type="text"
              id="registration_p1_register_code"
              placeholder="Enter code here"
              aria-labelledby="registration_p1_register_code_text"
              aria-describedby="registration_p1_register_code_error"
              onChange={this.handleChange.bind(this, "rCode")}
              data-atid="reg_p1_regcode"
            />
            {this.displayErrors("rCode", "registration_p1_register_code_error")}
          </div>
          {this.verificationError()}
          <Privacy />
          <Controls 
            next={this.next}
            dataAtId="reg_p1" 
          />
        </div>
      </div>
    )
  }
}